import { Trans, useTranslation } from 'react-i18next';
import { Socials } from './socials';
import Sprite from '../sprites/sprite';

export const Footer = () => {
  const { t } = useTranslation(['home', 'common']);

  return (
    <footer className="mt-16 md:mt-28 w-full bg-gradient-to-b from-emerald-100 via-emerald-200 to-emerald-300">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <div>
              <h2 className="text-2xl font-display text-emerald-900 mb-2">
                kumbh sukrit
              </h2>
              <p className="text-emerald-700 text-sm leading-relaxed">
                {t('home:footer.celebrate')}
              </p>
            </div>
            <div className="flex items-center gap-4">
              <Socials fill="#065f46" />
            </div>
          </div>

          {/* Explore Column */}
          <div className="space-y-4">
            <h3 className="text-emerald-900 font-semibold mb-3">Explore</h3>
            <div className="space-y-2">
              <a
                href="/magh-mela-2026"
                className="block text-emerald-700 hover:text-emerald-900 text-sm transition-colors"
              >
                Magh Mela 2026
              </a>
              <a
                href="/accommodations"
                className="block text-emerald-700 hover:text-emerald-900 text-sm transition-colors"
              >
                Accommodations
              </a>
              <a
                href="/magh-mela-2026/who-we-are"
                className="block text-emerald-700 hover:text-emerald-900 text-sm transition-colors"
              >
                About Us
              </a>
              <a
                href="/contact-us"
                className="block text-emerald-700 hover:text-emerald-900 text-sm transition-colors"
              >
                Contact
              </a>
            </div>
            <h3 className="text-emerald-900 font-semibold mb-3 pt-4">Legal</h3>
            <div className="space-y-2">
              <a
                href="/terms-of-service"
                className="block text-emerald-700 hover:text-emerald-900 text-sm transition-colors"
              >
                Terms of Service
              </a>
              <a
                href="/privacy-policy"
                className="block text-emerald-700 hover:text-emerald-900 text-sm transition-colors"
              >
                Privacy Policy
              </a>
              <a
                href="/cancellation-and-refund-policy"
                className="block text-emerald-700 hover:text-emerald-900 text-sm transition-colors"
              >
                Cancellation & Refund Policy
              </a>
            </div>
          </div>

          {/* Location Column */}
          <div className="space-y-6">
            <div>
              <h3 className="text-emerald-900 font-semibold mb-3 flex items-center gap-2">
                <svg
                  className="w-5 h-5 text-emerald-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                Camp Location
              </h3>
              <div className="space-y-2 text-emerald-700 text-sm">
                <p className="text-emerald-900 font-medium">
                  Open: 31 Dec 2025 – End of Feb 2026
                </p>
                <p>
                  Sector 22, Magh Mela
                  <br />
                  Prayagraj, UP 211019
                </p>
                <a
                  href="https://maps.app.goo.gl/yMaLiC9mCLvdcMrJ9"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-1 text-emerald-900 hover:text-emerald-700 font-medium"
                >
                  Open in Google Maps →
                </a>
              </div>
            </div>
            <div>
              <h3 className="text-emerald-900 font-semibold mb-3 flex items-center gap-2">
                <svg
                  className="w-5 h-5 text-emerald-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
                Bookings & Inquiries
              </h3>
              <div className="space-y-2 text-emerald-700 text-sm">
                <p>
                  <span className="text-emerald-900 font-medium">WhatsApp / Call:</span>
                  <br />
                  <span className="inline-flex items-center gap-1">
                    <Sprite
                      name="phone"
                      width="16"
                      height="16"
                      className="w-3.5 h-3.5 fill-current"
                    />
                    <span>/</span>
                    <Sprite name="whatsapp" width="24" height="24" className="w-4 h-4" />
                    <span>+91 84858 35675</span>
                  </span>
                </p>
              </div>
            </div>
          </div>

          {/* Support Column */}
          <div className="space-y-4">
            <h3 className="text-emerald-900 font-semibold mb-3 flex items-center gap-2">
              <svg
                className="w-5 h-5 text-emerald-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              On-Ground Support
            </h3>
            <div className="space-y-2 text-emerald-700 text-sm">
              <p>
                <span className="text-emerald-900 font-medium">
                  Mela Visits / Boat / Sangam:
                </span>
                <br />
                +91 99100 78872 / 080652 49725
              </p>
            </div>
          </div>
        </div>

        {/* Certifications */}
        <div className="mt-12 pt-8 border-t border-emerald-300">
          <p className="text-emerald-700 text-sm text-center mb-6">
            <Trans
              i18nKey="home:footer.sw"
              components={{
                link: (
                  // eslint-disable-next-line jsx-a11y/anchor-has-content
                  <a
                    className="text-emerald-900 font-semibold underline hover:text-emerald-700"
                    href="https://sukritwellness.com"
                  />
                ),
              }}
            />
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-6 border-t border-emerald-300/50">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-emerald-600 text-xs">
              © 2024 Kumbh Sukrit. All rights reserved.
            </p>
            <p className="text-emerald-600 text-xs">
              {t('common:product-of')}{' '}
              <a
                href="https://sukritwellness.com"
                className="text-emerald-800 hover:text-emerald-900 transition-colors font-medium"
              >
                Sukrit Wellness Tours Pvt Ltd
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
